import { Type } from "@angular/core";
import { Data, ParamMap } from "@angular/router";
import { Observable } from "rxjs";

import { CerFormDataNavigation } from "@form/cer-form-navigation.service";
import { CerFormContext } from "@form/cer-form-context";
import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormView } from "@form/cer-form-view";
import { CerRouteData } from "@app/app.module-generated";

export class CerFormRouteOptions {
  title: string;
  routeUrl: string;
  routeComponentType: Type<any>;
  routeAdapterType?: typeof CerFormAdapter;
  routeData: Data;
  routeParams: string[];
  paramMap?: Observable<ParamMap>;
  paramMapSnapshot?: ParamMap;
  queryParamMap?: Observable<ParamMap>;
  queryParamMapSnapshot?: ParamMap;
  navigation?: CerFormDataNavigation;
  parentView?: CerFormView;

  context: CerFormContext;
  callerData?: any = null;

  public data() : CerRouteData {
    return this.routeData as CerRouteData;
  }
  constructor(context: CerFormContext, callerData: any = null) {
    this.context = context;
    this.callerData = callerData;
  }
}
